import React, { useEffect, useRef } from "react";
import { getDataFromCmsApi } from "../../../api/contentful-service";
import { Avatar, Box } from "@mui/material";
import { useNavigate } from "react-router-dom"; // For redirection
import "animate.css";
import "./meet-the-team.scss";

function MeetTheTeamLink() {
    const [team, setTeam] = React.useState([]);
    const navigate = useNavigate();
    const containerRef = useRef(null);
    const memberRefs = useRef([]);

    useEffect(() => {
        // Fetch team data from an API or CMS
        const fetchTeamData = async () => {
            let response = await getDataFromCmsApi("Collection/ATC Team Member Homepage Circle");
            setTeam(response);
        };
        fetchTeamData();
    }, []);

    const handleClick = () => {
        // Redirect to the "Meet the Team" page
        navigate("exec-team");
    };

    const handleMouseEnter = () => {
        const members = memberRefs.current;
        const angleStep = (2 * Math.PI) / members.length;

        let radius = 150; // radius of circle
        const screenWidth = window.innerWidth;
        if (screenWidth <= 480) {
            radius = 85;
        } else if (screenWidth <= 768) {
            radius = 100;
        }

        members.forEach((ref, index) => {
            const angle = index * angleStep - Math.PI / 2; // Start from the top
            const x = Math.cos(angle) * radius;
            const y = Math.sin(angle) * radius;

            if (ref) {
                ref.style.transform = `translate(${x}px, ${y}px)`;
            }
        });
    };

    const handleMouseLeave = () => {
        memberRefs.current.forEach((ref) => {
            if (ref) {
                ref.style.transform = `translate(0, 0)`;
            }
        });
    };

    return (
        <Box
            className="team-container"
            ref={containerRef}
            onClick={handleClick}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className="meet-the-team team-flip-card" key="meetteam" style={{ zIndex: 100 }}>
                <div className="team-flip-card-inner">
                    {/* Front of the card */}
                    <div className="team-flip-card-front">
                        <Avatar
                            alt="Meet the team link"
                            src="./assets/images/team/meet-the-team.png"
                            className="meet-the-team-avatar"
                        />
                    </div>
                    {/* Back of the card */}
                    <div className="team-flip-card-back">
                        <Avatar
                            alt="Meet the team"
                            src="./assets/images/team/view-team-info.png"
                            className="meet-the-team-avatar"
                        />
                    </div>
                </div>
            </div>

            {team?.items?.map((member, index) => (
                <div
                    className="team-member"
                    key={index}
                    ref={(el) => (memberRefs.current[index] = el)}
                    style={{ zIndex: 10 - index }}
                >
                    <Avatar alt={member.position} src={member.imageUrl} className="team-member-avatar" />
                </div>
            ))}
        </Box>
    );
}

export default MeetTheTeamLink;
